<app-navbar></app-navbar>
<div class="screen-view">
    <router-outlet></router-outlet>
</div>

<app-footer></app-footer>

<app-up-button></app-up-button>